<template>
<div class="followers-card">
    <div @click="showfarmerdetails=true" class="flex farmer-details">
        <div class="flex farmer-name">  
            <img class="farmer-avatar"
                v-if="followedata.image" 
                :src="followedata.image.small"  
                alt=""
            />
            <img v-else class="mr-3 farmer-avatar" src="https://cdn.pixabay.com/photo/2015/03/04/22/35/avatar-659652_960_720.png" alt="">
            <p>{{followedata.full_name}}</p>
        </div>
        
        <div class="location">
            <span v-if="followedata.address && followedata.address.name.length<26">
            <p  class="loc">{{followedata.address.name}}</p>
            </span> 
            <v-tooltip v-else-if="followedata.address && followedata.address.length>25" top>
                <template v-slot:activator="{ on, attrs }">
                    <!-- <p v-bind="attrs" v-on="on" class="loc"> {{`${village} ${district} ${state}`}}</p>        -->
                    <p v-if="followedata.address" v-bind="attrs" v-on="on" class="loc">{{followedata.address.name}}</p> 
                    {{loc.length}}      
                </template>
                
                <span v-if="followedata.address">{{followedata.address.name}}</span>
            </v-tooltip>       
        </div>
    </div>
    <farmer-details :data="followedata" :dialog="showfarmerdetails"  @close="showfarmerdetails = false"/>
</div>
</template>


<script>
import farmerDetails from './farmer-details.vue'
export default {
    name : 'farmerdetails',

    data(){
        return{
            isActive : true, 
            showfarmerdetails: false,
            loc: "helloworldhereand ffefed"
            // village: this.getVillage(),
            // district: this.getDistrict(),
            // state: this.getState().toLowerCase(),
        }
    },
    methods:{
        // getLocation(loc){
        //     console.log(loc);
        //     if(this.followedata.address){
        //         if(`this.followedata.address.${loc}.eng_name`)
        //             return `this.followedata.address.${loc}.eng_name`
        //         else if(`this.followedata.address.${loc}.name`)
        //             return `this.followedata.address.${loc}.name`
        //         else if(`this.followedata.address.name`)
        //             return `this.followedata.address.name`
        //     }
        //     console.log(this.village);
        //     return " ";
        // },

        getVillage(){
            if(this.followedata.address){
                if(this.followedata.address.village.eng_name)
                    return this.followedata.address.village.eng_name;
                else if(this.followedata.address.village.name)
                    return this.followedata.address.village.name
                else if(this.followedata.address.name)
                    return  this.followedata.address.name
            }
            return " ";
        },
        getDistrict(){
            if(this.followedata.address){
                if(this.followedata.address.district.eng_name)
                    return this.followedata.address.district.eng_name;
                else if(this.followedata.address.district.name)
                    return this.followedata.address.district.name
                else if(this.followedata.address.name)
                    return  this.followedata.address.name
            }
            return " ";
        },
        getState(){
            if(this.followedata.address){
                if(this.followedata.address.state.eng_name)
                    return this.followedata.address.state.eng_name;
                else if(this.followedata.address.state.name)
                    return this.followedata.address.state.name
                else if(this.followedata.address.name)
                    return  this.followedata.address.name
            }
            return " ";
        }
    },
    components : {
        'farmer-details' : farmerDetails,
    },
    props :{
        followedata : Object
    }
}
</script>


<style lang="scss" scoped>
.followers-card{
    width: 100%;
    background-color: #FFFFFF;
    cursor: pointer;
}
.query-header-text p{
    cursor: pointer;
    margin: 0px 0px 0px 20px;
    font-size: 0.9rem;
    font-weight: 500;
    color: #A8A8A8;

    &.active{
        color: black;
        text-decoration: underline;
        text-underline-offset: 12px;
        text-decoration-thickness: 2px;
        text-decoration-color: #1D8D56;
    }
}
.farmer-details{
    // justify-content: flex-start;
    justify-content: space-around;
    padding: 10px 25px;
    p{
        margin-bottom: 0px;
    }
}
.farmer-name{
    justify-content: flex-start;
    align-items: center;
    width: 55%;
}
.farmer-avatar{
    margin-right: 10px;
    width: 34px;
    height: 34px;
}
.date{
    width: 20%;
}
.acre{
    width: 15%;
}
.loc{
    
    overflow: hidden;
    white-space: nowrap;  
    text-overflow:ellipsis;
}
.location{
    width: 45%;
    text-align: right;
}
.v-tooltip__content{
  background-color: #FFFFFF;
  color: #000000;
  border: 0.6px solid #979797;
  border-radius: 5px;
  max-width: 250px;
  min-width: 200px;
  text-align: center;
  font-size: 13px;
  padding: 10px 12px;
}
</style>